import { useEffect } from 'react';

var useOnEscape = function useOnEscape(onEscapeKey) {
  return useEffect(function () {
    var keyDownHandler = function keyDownHandler(e) {
      e.keyCode === 27 && onEscapeKey && onEscapeKey();
    };
    onEscapeKey && document.addEventListener('keydown', keyDownHandler);
    return function () {
      onEscapeKey && document.removeEventListener('keydown', keyDownHandler);
    };
  }, [onEscapeKey]);
};

export { useOnEscape };
//# sourceMappingURL=use-on-escape.esm.js.map
